
// Check time and set day or night theme logic
document.addEventListener("DOMContentLoaded", function() {
    const hour = new Date().getHours();
    const wrapper = document.querySelector('.mapWrapper');

    if (hour >= 6 && hour < 18) {
        // Morning: 6 AM - 12 PM
        wrapper.classList.add('light-mode');
    } else if (hour >= 18 || hour < 6) {
        // Afternoon: 12 PM - 6 PM
        wrapper.classList.add('dark-mode');
    }
});

// Function to handle opening the drawer
let currentContentId = null; // Track the current content ID
const footer = document.getElementById('avestan-footer');

document.querySelectorAll('.wrapMapFlag').forEach(function(trigger) {
  trigger.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevent the click event from propagating to the document

      var contentId = this.getAttribute('data-content');

      // If the drawer is already open with the same content, do nothing
      if (contentId === currentContentId) {
          return;
      }

      var drawer = document.getElementById('popupDrawer');
      var drawerContent = document.getElementById('drawerContent');

      // Check if a URL redirection is needed
      let redirectUrl = checkForRedirect(contentId);
      if (redirectUrl) {
          window.location.href = redirectUrl;
          return;
      }

      // Close the drawer if it's open
      if (drawer.classList.contains('open')) {
          drawer.classList.remove('open');          

          // Set a timeout to allow the close animation to complete before opening again
          setTimeout(function() {
              updateDrawerContent(contentId);
              drawer.classList.add('open');
              document.body.classList.add('drawer-open');
              if (footer.style.bottom === '0px') {
                footer.style.bottom = '-36rem';
              }
            
              document.getElementById('footer-subscribe').classList.remove('active');
            
              window.removeEventListener('wheel', handleScrollAttempt);
          }, 300);
      } else {
          // If the drawer is not open, open it with the new content
          updateDrawerContent(contentId);
          drawer.classList.add('open');
          document.body.classList.add('drawer-open');
          if (footer.style.bottom === '0px') {
            footer.style.bottom = '-36rem';
          }
          document.getElementById('footer-subscribe').classList.remove('active');
          window.removeEventListener('wheel', handleScrollAttempt);
      }

      currentContentId = contentId; // Update the current content ID
  });
});

// Function to update the drawer content
function updateDrawerContent(contentId) {
    var coordinates, name, productLinks, info, journeyLink;

    switch(contentId) {
        case 'content2':
            coordinates = '78° 13’ N 15° 33’ E';
            onlyAvailableAt = 'Only available at <a href="/pages/stores#svalbard">248 Elizabeth St, New York</a>';
            name = 'SVALBARD';
            productLinks = '<a href="/products/svalbard-eau-de-parfum">SVALBARD Eau de Parfum</a><a href="/products/svalbard-perfume-oil">SVALBARD Perfume Oil</a><a href="/products/svalbard-candle">SVALBARD Candle</a>';
            info = 'Svalbard is a concrete preservation depository of delicate plant seed in the remote Arctic. This fragrance borrows aromas from the seeds, the concrete, and the Arctic environment, for a distant yet pleasing journey of the mind.';
            journeyLink = '<a href="/pages/svalbard" class="journey-link">Explore Journey</a>';
            break;
        case 'content3':
            coordinates = '31° 15’ N 7° 59’ W';
            onlyAvailableAt = 'Only available at <a href="/pages/stores#avestan">73 Beak St., London</a>';
            name = 'AVESTAN';
            productLinks = '<a href="/products/avestan-eau-de-parfum">AVESTAN Eau de Parfum</a><a href="/products/avestan-perfume-oil">AVESTAN Perfume Oil</a><a href="/products/avestan-candle">AVESTAN Candle</a>';
            info = '';
            journeyLink = '<a href="pages/asni-village" class="journey-link">Explore Journey</a>';
            break;
        default:
            coordinates = 'Unknown';
            name = 'Unknown Location';
            productLinks = '<a href="#">Unknown Product</a>';
            info = 'No information available.';
            journeyLink = '';
    }

    var drawerContent = document.getElementById('drawerContent');

    // Update the content dynamically
    drawerContent.innerHTML = `
      <div class="journey">
        <span class="coordinates">${coordinates}</span><br />
        <span class="name">${name}</span>
      </div>
      <div class="products">
        ${productLinks}
      </div>
      <div class="info">
        <p class="map-onlyavailable-title">${onlyAvailableAt}</p>
        <span>${info}</span>
        ${journeyLink}
      </div>
    `;
}

// Function to check if the content ID requires a redirect
function checkForRedirect(contentId) {
    switch(contentId) {
        case 'content1':
            return '/pages/tent-in-mahale'; // Redirect URL for content1
        // case 'content2':
        //     return '/pages/svalbard'; // Redirect URL for content2
        case 'content4':
            return '/pages/roofs-of-beni-isgue'; // Redirect URL for content2
        default:
            return null; // No redirect needed
    }
}

// Close drawer on click of close button
document.querySelector('.close-drawer').addEventListener('click', function(event) {
  event.stopPropagation(); // Prevent the click event from propagating to the document
  var drawer = document.getElementById('popupDrawer');
  if (drawer.classList.contains('open')) {
      drawer.classList.remove('open');
      document.body.classList.remove('drawer-open');
      window.addEventListener('wheel', handleScrollAttempt);
  }
  currentContentId = null; // Reset the current content ID
});

// Close drawer when clicking outside of it
document.addEventListener('click', function(event) {
  var drawer = document.getElementById('popupDrawer');
  if (drawer.classList.contains('open') && !drawer.contains(event.target)) {
      drawer.classList.remove('open');
      document.body.classList.remove('drawer-open');
      currentContentId = null; // Reset the current content ID
      window.addEventListener('wheel', handleScrollAttempt);
  }
});

function toggleAudio() {
  var audioPlayer = document.getElementById('audio-player');
  var btn = document.getElementById('map-sound-btn');
  if (audioPlayer.paused) {
    audioPlayer.play();
    localStorage.setItem('audioPlaying', 'true');
    btn.classList.add('playing');
  } else {
    audioPlayer.pause();
    localStorage.setItem('audioPlaying', 'false');
    btn.classList.remove('playing');
  }
}

document.getElementById('map-sound-btn').addEventListener('click', toggleAudio);

window.addEventListener('load', function() {
  var audioPlayer = document.getElementById('audio-player');
  var audioPlaying = localStorage.getItem('audioPlaying') === 'true';
  if (audioPlaying) {
    audioPlayer.play().catch(function() {});
    document.getElementById('map-sound-btn').classList.add('playing');
  }
});

